import { gql } from 'data/graphql/utils/gql';
import { fImage, fBlockFunnelStepImageUpload } from 'data/graphql/fragments';

const GET_TY_TREATMENT_PAGE = gql`
  query getTreatmentPage(
    $locale: String!
    $preview: Boolean!
    $treatmentName: [String]
  ) {
    collection: treatmentPageCollection(
      locale: $locale
      preview: $preview
      limit: 10
      where: { textAliases_contains_all: $treatmentName }
    ) {
      ...treatmentPageFields
    }
  }
  fragment treatmentPageFields on TreatmentPageCollection {
    items {
      sys {
        id
        publishedAt
        firstPublishedAt
      }
      slug
      disableIndexing
      textAliases
      disableLocale
      title
      treatmentName
      blogPosts: blogPostsCollection(limit: 3) {
        items {
          title
          slug
          excerpt
          bannerImage {
            ...fImage
          }
        }
      }
      faq: faqCollection(limit: 3) {
        items {
          question: title
          disableLocale
          answer: text {
            json
          }
        }
      }
      imageUploads {
        ...cbBlockFunnelStepImageUpload
      }
      onboardingComment
      richTextStart {
        json
      }
    }
  }

  ${fImage}
  ${fBlockFunnelStepImageUpload}
`;

export default GET_TY_TREATMENT_PAGE;
